import { isValidType } from "./general";

export const getValidType = <T extends string | number>(
	value: unknown,
	validValues: T[] | readonly T[],
): T | undefined => (isValidType(value, validValues) ? value : undefined);
